import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Box, Item } from '../../atoms';
import Toolbar from '../../molecules/Toolbar';
import { Subtitle } from './sidebar-menu.styles';

const SidebarHeading = ({
  data,
  onMenuHeaderClick
}) => {
  var _data$subtitles, _data$helpers;

  const hasSubtitles = ((_data$subtitles = data.subtitles) == null ? void 0 : _data$subtitles.length) > 0;
  return /*#__PURE__*/React.createElement(Box, {
    bg: "background.primary",
    "data-testid": "sidebar-header"
  }, /*#__PURE__*/React.createElement(Item, {
    scale: "medium",
    endIcon: "ChevronRight",
    fontWeight: "medium",
    variant: "primary",
    as: "a",
    ellipsis: data == null ? void 0 : data.ellipsis,
    href: data == null ? void 0 : data.url,
    rel: data == null ? void 0 : data.rel,
    onClick: e => onMenuHeaderClick(e, {
      url: data == null ? void 0 : data.url
    })
  }, data == null ? void 0 : data.label), hasSubtitles && data.subtitles.map(sub => /*#__PURE__*/React.createElement(Subtitle, {
    key: sub
  }, sub)), /*#__PURE__*/React.createElement(Toolbar, {
    variant: "primary"
  }, data == null ? void 0 : (_data$helpers = data.helpers) == null ? void 0 : _data$helpers.map((item, index) => /*#__PURE__*/React.createElement(Toolbar.Item, {
    key: index,
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: item == null ? void 0 : item.id,
    onClick: e => onMenuHeaderClick(e, item)
  }, item == null ? void 0 : item.label))));
};

SidebarHeading.defaultProps = {
  onMenuHeaderClick: () => {}
};
process.env.NODE_ENV !== "production" ? SidebarHeading.propTypes = {
  onMenuHeaderClick: func,
  data: shape({
    label: string.isRequired,
    subtitles: arrayOf(string),
    ellipsis: bool,
    url: string.isRequired,
    helpers: arrayOf(shape({
      id: string.isRequired,
      label: string.isRequired,
      url: string.isRequired
    })).isRequired
  }).isRequired
} : void 0;
export default SidebarHeading;